// extracted by mini-css-extract-plugin
export var autumn = "beauty-type-module--autumn--H7RnM";
export var beautyPage = "beauty-type-module--beauty-page--6yRe3";
export var discoveryMain = "beauty-type-module--discovery-main--7Lk6R";
export var discoveryQuiz = "beauty-type-module--discovery-quiz--p68dI";
export var discoverySection = "beauty-type-module--discovery-section--JeOTJ";
export var discoveryStep = "beauty-type-module--discovery-step--S9hyj";
export var discoverySteps = "beauty-type-module--discovery-steps--KqEjc";
export var finalCopy = "beauty-type-module--final-copy--t2Wdq";
export var finalCta = "beauty-type-module--final-cta--PpOuA";
export var finalFeature = "beauty-type-module--final-feature--kFKeP";
export var finalFeatureIcon = "beauty-type-module--final-feature-icon---bbxl";
export var finalFeatures = "beauty-type-module--final-features--roiBW";
export var finalPalette = "beauty-type-module--final-palette--2ZIZf";
export var hero = "beauty-type-module--hero--3UEse";
export var heroBadge = "beauty-type-module--hero-badge--BYb8L";
export var heroBenefit = "beauty-type-module--hero-benefit--RuD+-";
export var heroBenefits = "beauty-type-module--hero-benefits--D1UCG";
export var heroCopy = "beauty-type-module--hero-copy--ZGwaw";
export var heroCta = "beauty-type-module--hero-cta--rm-tm";
export var heroEyebrow = "beauty-type-module--hero-eyebrow--DqhEo";
export var heroLead = "beauty-type-module--hero-lead--gnVMh";
export var heroTitle = "beauty-type-module--hero-title--zkOZM";
export var heroVisual = "beauty-type-module--hero-visual--poiw8";
export var lookBody = "beauty-type-module--look-body--Mdrsv";
export var lookCard = "beauty-type-module--look-card--qZNEL";
export var lookImage = "beauty-type-module--look-image--vCef+";
export var lookLink = "beauty-type-module--look-link--KVnSF";
export var lookSeason = "beauty-type-module--look-season--hdZJb";
export var looksGrid = "beauty-type-module--looks-grid--YrRKd";
export var pageShell = "beauty-type-module--page-shell--czcHr";
export var palette = "beauty-type-module--palette--vZNxF";
export var paletteLabel = "beauty-type-module--palette-label--al1EG";
export var quizButterfly = "beauty-type-module--quiz-butterfly--XJo7w";
export var quizLink = "beauty-type-module--quiz-link--cYYw8";
export var seasonBody = "beauty-type-module--season-body--3GrP2";
export var seasonCard = "beauty-type-module--season-card--UGrEt";
export var seasonDetails = "beauty-type-module--season-details--Yc4mF";
export var seasonGrid = "beauty-type-module--season-grid--rNm+j";
export var seasonHeader = "beauty-type-module--season-header--vKjiC";
export var seasonImage = "beauty-type-module--season-image--hS92L";
export var seasonLink = "beauty-type-module--season-link--5kOOk";
export var seasonTagline = "beauty-type-module--season-tagline--A2m2D";
export var section = "beauty-type-module--section--ahuPX";
export var sectionHeading = "beauty-type-module--section-heading--CFMqz";
export var spring = "beauty-type-module--spring--yz2JX";
export var stepArrow = "beauty-type-module--step-arrow--GNDwL";
export var stepIcon = "beauty-type-module--step-icon--5JJW4";
export var stepIconImage = "beauty-type-module--step-icon-image--gA5EX";
export var summer = "beauty-type-module--summer--Ko+Qd";
export var swatch = "beauty-type-module--swatch---NE1P";
export var winter = "beauty-type-module--winter--A3r2h";